import { ReactComponent as Logo } from 'assets/summerwood_logo.svg';
import React from 'react';

export interface SummerwoodLogoProps {
  isSmallScreen: boolean;
}

const SummerwoodLogo: React.FunctionComponent<SummerwoodLogoProps> = ({ isSmallScreen }) => {
  return (
    <Logo
      style={{
        margin: isSmallScreen ? '4px' : '0px 15px',
        maxWidth: '256px',
        height: isSmallScreen ? '24px' : 'auto',
      }}
    />
  );
};

export default SummerwoodLogo;
